"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M26.827 6.93098L12.8385 21.6189C11.6563 22.8603 9.67598 22.8603 8.49371 21.6189L1.17188 13.931L4.06843 11.1724L10.6661 18.0999L23.9305 4.17236L26.827 6.93098Z", fill: "currentColor" }));
